<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="currentColor"
  >
    <path
      d="M280-40q-20-40-30-98t-10-118q0-99 22-163.5T320-520v-200l120-200h80l120 200v200q37 36 58.5 100.5T720-256q0 60-10 118t-30 98q-42-13-67-47.5T589-166q0-25 5.5-54t5.5-58q0-58-31.5-122T480-520q-56 56-88 120t-32 122q0 29 6 58t7 54q0 44-25.5 79T280-40Zm200-600q-17 0-28.5-11.5T440-680q0-11 5-20t15-14v-85l-60 101v98h160v-98l-60-101v85q10 5 15 14t5 20q0 17-11.5 28.5T480-640Zm20-159h-40 40Zm-40 0h40-40Z"
    />
  </svg>
</template>
